import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { UploadAndViewPdf } from '@components';
import { API } from '@service';
import { uploadUserGuideRequest } from '@service/apis';
import {
  PDFDownload,
  PDFTitle,
} from '@components/hubModule/pdfTitleAndDownload';
import { injectPDFStyleOnIframeLoad } from '@utils/common';

function PDFViewControl({ pdf, setPdf, type }) {
  const [uploadStatus, setUploadStatus] = useState();
  const [statusDisplayProperty, setStatusDisplayProperty] = useState('flex');
  useEffect(() => {
    fulfillContentFromServer();
  }, []);

  function fulfillContentFromServer() {
    (async () => {
      const { fileName, data } = await API.getUserGuideRequest(type);
      setPdf({ contentBlob: data, fileName });
    })();
    return () => {
      URL.revokeObjectURL(pdf);
    };
  }

  const updatePdfFileName = () => {
    fulfillContentFromServer();
    setStatusDisplayProperty('flex');
  };

  const handleUploadStatus = (isSuccess) => {
    setUploadStatus(isSuccess);
    setTimeout(() => {
      setStatusDisplayProperty('none');
      setUploadStatus();
    }, 3000);
  };

  return (
    <div className="pdf-controller">
      {uploadStatus === true && (
        <div
          className="badger success"
          style={{ display: statusDisplayProperty }}
        >
          <span>SUCCESS</span>
          <span>PDF uploaded successfully</span>
        </div>
      )}
      {uploadStatus === false && (
        <div
          className="badger error"
          style={{ display: statusDisplayProperty }}
        >
          <span>ERROR</span>
          <span>PDF failed to upload</span>
        </div>
      )}
      <Button className="user-guide-setting-button" type="primary">
        <UploadAndViewPdf
          changeLink={updatePdfFileName}
          handleStatus={handleUploadStatus}
          uploadAPI={uploadUserGuideRequest}
          type={type}
          uploadOnlyNoEditAndDelete
        />
      </Button>
      {pdf.contentBlob ? (
        <div
          style={{ position: 'relative', width: '100%', marginTop: '0.938rem' }}
        >
          <PDFTitle pdfContent={pdf} />
          <PDFDownload pdfContent={pdf} style={{ top: '0.75rem' }} />
          <iframe
            src={`${URL.createObjectURL(pdf.contentBlob)}`}
            name="internal"
            className="tab-internal no-margin"
            onLoad={injectPDFStyleOnIframeLoad}
          />
        </div>
      ) : (
        <div className="empty-pdf">PDF</div>
      )}
    </div>
  );
}

export default PDFViewControl;
